import { combineReducers } from 'redux';

import AssembleiasReducer, {
  IAssembleiasAssociadoReducer,
} from './modules/AssembleiasAssociadoReducer';
import AssembleiasAssessorReducer, {
  IAssembleiasAssessorReducer,
} from './modules/AssembleiasAssessorReducer';
import LeftMenuReducer, { ILeftMenuReducer } from './modules/LeftMenuReducer';
import AuthReducer, { IAuthReducer } from './modules/AuthReducer';
import ModalsReducer, { IModalsReducer } from './modules/ModalsReducer';
import WSAssembleiasReducer, {
  IWSAssembleiasReducer,
} from './modules/WSAssembleiasReducer';

import AssessorReducer from './modules/assessor/reducer';
import { IAssessorReducer } from './modules/assessor/interfaces';

import AssociadoReducer from './modules/associado/reducer';
import { IAssociadoReducer } from './modules/associado/interfaces';
import { Reducer } from 'react';
import ModalReducer, { ModalReducerType } from './modules/ModalReducer';

export interface IReducer {
  assembleias: IAssembleiasAssociadoReducer;
  assembleiasAssessor: IAssembleiasAssessorReducer;
  assessor: IAssessorReducer;
  associado: IAssociadoReducer;
  leftMenu: ILeftMenuReducer;
  auth: IAuthReducer;
  modals: IModalsReducer;
  modal: ModalReducerType;
  wsAssembleias: IWSAssembleiasReducer;
}

export const getReducer = (): any => {
  return combineReducers({
    assembleias: AssembleiasReducer,
    assembleiasAssessor: AssembleiasAssessorReducer,
    assessor: AssessorReducer as Reducer<any, any>,
    associado: AssociadoReducer as Reducer<any, any>,
    auth: AuthReducer as Reducer<any, any>,
    leftMenu: LeftMenuReducer as Reducer<any, any>,
    modals: ModalsReducer as Reducer<any, any>,
    modal: ModalReducer as Reducer<any, any>,
    wsAssembleias: WSAssembleiasReducer,
  });
};
